import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
import { DeleteModuleActivityDialogComponent } from '../../courses/delete-module-activity-dialog/delete-module-activity-dialog.component';

@Component({
  selector: 'app-list-batch',
  templateUrl: './list-batch.component.html',
  styleUrls: ['./list-batch.component.scss']
})
export class ListBatchComponent implements OnInit {

  isLoading: boolean = true;
  listOfBatch: any = [];
  listOfBatchToDisplay: any = [];
  userDetails: any;

  constructor(
    private router: Router,
    public as: AppService,
    private toastr: ToastrService,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    this.fetchAllBatches();
  }

  async fetchAllBatches() {
    this.isLoading = true;
    this.listOfBatch = [];
    this.listOfBatchToDisplay = [];
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.userDetails['accessToken']}`,
    });
    const URL = `${webApi.domain + webApi.endPoint.fetchAllBatches}`;
    await this.as
      .fetchDetail({ fetchAll: true }, URL, httpHeaders)
      .then((data: any) => {
        if (data['success']) {
          this.listOfBatchToDisplay = data['result'];
          this.listOfBatch = this.listOfBatchToDisplay;

          this.isLoading = false;
        }
      });
  }
  searchBatch(event: any) {
    // console.log(event.target.value);
    let serachQuery = event.target.value;
    let tempBatchList: any = [];
    this.listOfBatchToDisplay = [...this.listOfBatch];
    if (serachQuery != '') {
      this.listOfBatchToDisplay.forEach((batch: any) => {
        if (
          String(batch['title'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase()) ||
          String(batch['batchName'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase())
        ) {
          tempBatchList.push(batch);
        }
      });
      this.listOfBatchToDisplay = [...tempBatchList];
    } else {
      this.listOfBatchToDisplay = [...this.listOfBatch];
    }
  }

  deleteBatch(batch: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { source: 'Batch Delete', batch: batch };
    let dialogRef = this.matDialog.open(
      DeleteModuleActivityDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      // console.log(res);
      if (res == null) {
        this.listOfBatchToDisplay.forEach((course: any) => {
          course['isDeleting'] = false;
        });
        return;
      } else {
        const param = {
          batchId: res['value']['_id'],
          action: 'Delete',
        };
        const httpHeaders = new HttpHeaders({
          Authorization: `Bearer ${this.userDetails['accessToken']}`,
        });
        const URL = `${webApi.domain + webApi.endPoint.activeAndDeleteBatch}`;
        await this.as
          .postMethodWithToken(param, URL, httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              this.listOfBatchToDisplay.forEach((course: any, index: number) => {
                if (course['_id'] == res['value']['_id']) {
                  this.listOfBatchToDisplay.splice(index, 1);
                }
              });
              this.showSuccessToaster('Batch Delete Successfully', 'Success');
            } else {
              this.listOfBatchToDisplay.forEach((course: any, index: number) => {
                if (course['_id'] == res['value']['_id']) {
                  course['isDeleting'] = false;
                }
              });
              this.showErrorToaster(
                'Error Occurred while deleteing Batch. Try again',
                'Error'
              );
            }
          });
      }
    });
  }

  addNewBatch() {
    this.router.navigate(['/catalog/add-batch']);
  }
  gotoBatchEdit(info: any) {
    this.router.navigate(['/catalog/edit-batch'], { queryParams: { id: info._id } });
  }

  viewAnnouncement(batchId: String) {
    this.router.navigate(['/catalog/batch-announcement', { batchId: batchId }]);
  }
  courseUserList(batchId: String) {
    this.router.navigate(['/catalog/batch-enroled-user', { batchId: batchId }]);
  }

  async updateBatchStatus(batch: any) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { source: 'Batch Status', batch: batch };
    let dialogRef = this.matDialog.open(
      DeleteModuleActivityDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      // console.log(res);
      if (res == null) {
        // this.listOfBatchToDisplay.forEach((course: any) => {
        //   course['isDeleting'] = false;
        // });
        return;
      } else {

        const httpHeaders = new HttpHeaders({
          Authorization: `Bearer ${this.userDetails['accessToken']}`,
        });
        const param = {
          batchId: batch['_id'],
          isActive: batch['isActive'] ? false : true,
          action: 'Active',
        };
        const URL = `${webApi.domain + webApi.endPoint.activeAndDeleteBatch}`;
        await this.as
          .postMethodWithToken(param, URL, httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              this.listOfBatchToDisplay.forEach((crs: any) => {
                if (crs['_id'] == batch['_id']) {
                  crs['isActive'] = batch['isActive'] ? false : true;
                }
              });
              this.showSuccessToaster(
                !batch['isActive']
                  ? 'Batch Unpublished Successfully'
                  : 'Batch Published Successfully',
                'Success'
              );
            }
          });
      }
    });

  }
  gotoActivity(info: any) {
    this.router.navigate(['/catalog/batch-activity'], { queryParams: { batchId: info._id } });
  }
  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }

}
